<mat-toolbar class="header-color">
  <mat-toolbar-row *ngIf="auth.canEdit(user); else productLabel">
    <span> Products </span>
    <span class="example-spacer"></span>
    <button class="btn button" (click)="onNewProduct()">
      Add Product
    </button>
    <button class="btn button" (click)="import()">
      Import
    </button>
  </mat-toolbar-row>
  <ng-template #productLabel>
    <mat-toolbar-row>
      <span> Products </span>
    </mat-toolbar-row>
  </ng-template>

</mat-toolbar>
<!-- <div class="row">
  <div class="col-md-5" style="margin:50px"> -->
    <app-list-product></app-list-product>
  <!-- </div>
  <div class="col-md-5" style="margin:50px">
    <router-outlet></router-outlet>
  </div>
</div> -->
